// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"8c640583","453":"4daaf859","551":"faac0a3e","720":"9db66ed8","979":"3f3d91a0"}[chunkId] + ".chunk.js";
};